import { render, staticRenderFns } from "./DetailsInjuryForm.vue?vue&type=template&id=6cc251de&"
import script from "./DetailsInjuryForm.vue?vue&type=script&lang=ts&"
export * from "./DetailsInjuryForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports